var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _vm.reservation.show || 1
                        ? _c(
                            "v-container",
                            { attrs: { fluid: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c("h2", [
                                      _vm._v(
                                        "Edit Additional Fees and Taxes (" +
                                          _vm._s(
                                            _vm.reservation.additional_fees
                                              .length
                                          ) +
                                          ")"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "All prices are in " +
                                          _vm._s(
                                            _vm.reservation.hotel.hotel_name
                                          ) +
                                          "'s local currency " +
                                          _vm._s(
                                            _vm.reservation.hotel.currency
                                              .currency_name
                                          )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Note: this is for display only, and does not yet save"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Note: this does not yet support the old taxes set up through legacy admin; only new taxes and fees applied as new Additional Fees in Portal"
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c("h3", [
                                      _vm._v("Add New Property Fees and Taxes"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  !_vm.hotelFees.length
                                    ? _c("v-col", { attrs: { cols: "12" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.reservation.hotel.hotel_name
                                          ) +
                                            " does not have any standard fees or taxes"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hotelFees.length
                                    ? _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _vm._v(
                                            "\n                                   " +
                                              _vm._s(
                                                _vm.reservation.hotel.hotel_name
                                              ) +
                                              " supports the following fees and taxes.  Click the + Apply button to add it to this reservation, or click the Add Customised Fee button at the bottom to create a bespoke fee.\n                                   "
                                          ),
                                          _vm._l(
                                            _vm.hotelFees,
                                            function (fee, index) {
                                              return _c(
                                                "fieldset",
                                                [
                                                  _c("legend", [
                                                    _vm._v(_vm._s(fee.name)),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    { attrs: { row: "" } },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              fee.description
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "10" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                           " +
                                                              _vm._s(
                                                                fee.fee_value
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                fee.fee_application_type ==
                                                                  2
                                                                  ? "%"
                                                                  : _vm
                                                                      .reservation
                                                                      .hotel
                                                                      .currency
                                                                      .currency_code
                                                              ) +
                                                              "\n                                           " +
                                                              _vm._s(
                                                                _vm.feeCategoryAsString(
                                                                  fee.hotel_additional_fee_type_key
                                                                )
                                                              ) +
                                                              ", \n                                           billed " +
                                                              _vm._s(
                                                                _vm.feeTypeAsString(
                                                                  fee.fee_application_type
                                                                )
                                                              ) +
                                                              ",\n                                           payable to " +
                                                              _vm._s(
                                                                _vm.feePayableAsString(
                                                                  fee.is_payable_to
                                                                )
                                                              ) +
                                                              "\n                                       "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "2" },
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                title:
                                                                  "Apply this fee to the reservation",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.applyHotelFee(
                                                                      fee
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v("add"),
                                                              ]),
                                                              _vm._v(
                                                                " Apply\n                                           "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "fieldset",
                                            [
                                              _c("legend", [_vm._v("Custom")]),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "10" } },
                                                [
                                                  _vm._v(
                                                    "Apply a new blank fee which can be customised as needed"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "2" } },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        title:
                                                          "Add a new customised fee you can configure yourself",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addNewCustomFee()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("add"),
                                                      ]),
                                                      _vm._v(
                                                        " Apply Customised Fee\n                                           "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mt-4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c("h3", [
                                        _vm._v(
                                          "Edit The Fees and Taxes Applied to This Booking"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    _vm._l(
                                      _vm.reservation.additional_fees,
                                      function (fee, index) {
                                        return _c(
                                          "fieldset",
                                          [
                                            _c("legend", [
                                              _vm._v(
                                                "Fee " + _vm._s(index + 1)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "" } },
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "4" } },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: { label: "Name" },
                                                      model: {
                                                        value: fee.name,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            fee,
                                                            "name",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "fee.name",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "8" } },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: "Description",
                                                      },
                                                      model: {
                                                        value: fee.description,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            fee,
                                                            "description",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "fee.description",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "2" } },
                                                  [
                                                    _c("v-autocomplete", {
                                                      attrs: {
                                                        dense: "",
                                                        outlined: "",
                                                        label: "Category",
                                                        items:
                                                          _vm.categoryOptions,
                                                        autocomplete: "",
                                                      },
                                                      model: {
                                                        value:
                                                          fee.hotel_additional_fee_type_key,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            fee,
                                                            "hotel_additional_fee_type_key",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "fee.hotel_additional_fee_type_key",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "2" } },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: { label: "Value" },
                                                      model: {
                                                        value: fee.fee_value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            fee,
                                                            "fee_value",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "fee.fee_value",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      "\n                                           " +
                                                        _vm._s(
                                                          fee.fee_application_type ==
                                                            2
                                                            ? "%"
                                                            : _vm.reservation
                                                                .hotel.currency
                                                                .currency_code
                                                        ) +
                                                        "\n                                       "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "3" } },
                                                  [
                                                    _c("v-autocomplete", {
                                                      attrs: {
                                                        dense: "",
                                                        outlined: "",
                                                        label: "Application",
                                                        items:
                                                          _vm.applicationOptions,
                                                        autocomplete: "",
                                                      },
                                                      model: {
                                                        value:
                                                          fee.fee_application_type,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            fee,
                                                            "fee_application_type",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "fee.fee_application_type",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "3" } },
                                                  [
                                                    _c("v-autocomplete", {
                                                      attrs: {
                                                        dense: "",
                                                        outlined: "",
                                                        label: "Payee",
                                                        items: _vm.payeeOptions,
                                                        autocomplete: "",
                                                      },
                                                      model: {
                                                        value:
                                                          fee.is_payable_to,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            fee,
                                                            "is_payable_to",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "fee.is_payable_to",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "2" } },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          title:
                                                            "Remove this fee from the reservation",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeFee(
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v("delete"),
                                                        ]),
                                                        _vm._v(
                                                          " Remove\n                                           "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            title: "Cancel without changes",
                                          },
                                          on: { click: _vm.cancel },
                                        },
                                        [_vm._v("Cancel")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ies-green",
                                          attrs: {
                                            title:
                                              "Save changes to taxes and fees",
                                          },
                                          on: { click: _vm.save },
                                        },
                                        [
                                          _c("v-icon", [_vm._v("save")]),
                                          _vm._v(
                                            " Save\n                                   "
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }